import { render, staticRenderFns } from "./buyCryptocurrency.vue?vue&type=template&id=47621b3f"
import script from "./buyCryptocurrency.vue?vue&type=script&lang=js"
export * from "./buyCryptocurrency.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports